import { render, staticRenderFns } from "./settings-configuration.vue?vue&type=template&id=5cf77471&"
import script from "./settings-configuration.vue?vue&type=script&lang=ts&"
export * from "./settings-configuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports